webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(54);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(114);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	    el: '#app',
	    render: function render(h) {
	        return h(_App2.default);
	    },
	
	    components: {
	        'app': _App2.default
	    }
	});

/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(60);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _validator = __webpack_require__(58);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function leoAlert(data) {
	    setTimeout(function () {
	        alert((0, _stringify2.default)(data, null, 4));
	    });
	}
	
	exports.default = {
	    name: 'app',
	    components: {
	        'leo-validator': _validator2.default
	    },
	    data: function data() {
	        return {
	            form1: [{
	                key: 'formKey1',
	                value: '',
	                rules: [{
	                    rule: 'required', tip: '请输入活动名称'
	                }, {
	                    rule: 'isCode', tip: '邮政编码不正确（leo）'
	                }],
	                state: 0,
	                msg: ''
	            }, {
	                key: 'formKey2',
	                value: 'wahahha',
	                rules: function rules(value, rule, item, cb) {
	                    item.msg = 'loading';
	                    setTimeout(function () {
	                        cb(function (newVal, rule, item) {
	                            item.state = 1;
	                            item.msg = '成功';
	                        });
	                    }, 1000);
	                },
	
	                state: 0,
	                msg: ''
	            }],
	            form2: [{
	                key: 'form2Item1',
	                value: '',
	                rules: [{
	                    rule: 'required', tip: '不能为空'
	                }, {
	                    rule: 'isPhone', tip: '手机号码格式不对'
	                }],
	                state: 0,
	                msg: ''
	            }, {
	                key: 'form2Item2',
	                value: '',
	                state: 0,
	                msg: ''
	            }, {
	                key: 'form2Item3',
	                value: {
	                    user: 'leo',
	                    password: ''
	                },
	                rules: [{
	                    rule: function rule(value, _rule, item, cb, index) {
	                        if (value.user === '') {
	                            item.msg = 'user不能为空';
	                            item.state = 2;
	                            cb();
	                            return;
	                        }
	                        item.msg = 'user验证中';
	                        setTimeout(function () {
	                            cb(function (newVal, rule, item) {
	                                if (newVal.user.length > 6) {
	                                    item.state = 2;
	                                    item.msg = 'user不正确';
	                                } else {
	                                    item.state = 1;
	                                    item.msg = 'user验证成功';
	                                }
	                            });
	                        }, 1000);
	                    }
	                }, {
	                    rule: function rule(value, _rule2, item, cb, index) {
	                        item.msg = 'password验证中';
	                        setTimeout(function () {
	                            cb(function (newVal, rule, item) {
	                                if (newVal.password == 123456) {
	                                    item.state = 1;
	                                    item.msg = 'password验证成功';
	                                } else {
	                                    item.state = 2;
	                                    item.msg = 'password不正确';
	                                }
	                            });
	                        }, 1000);
	                    }
	                }],
	                errorCb: function errorCb(e, item, i) {
	                    leoAlert(e.name);
	                    console.log(e, item, i);
	                },
	
	                state: 0,
	                msg: '',
	                deep: true }, {
	                key: 'form2Item4',
	                value: ['leo', 'leoWa'],
	                rules: [{
	                    rule: function rule(value, _rule3, item, cb, index) {
	                        if (value[0] === '' || value[1] === '') {
	                            item.msg = 'input都不能为空';
	                            item.state = 2;
	                            cb();
	                            return;
	                        }
	                        item.state = 3;
	                        item.msg = '验证中';
	                        item.timerId = setTimeout(function () {
	                            item.timerId = null;
	                            cb(function (newVal, rule, item) {
	                                if (newVal[0] == newVal[1]) {
	                                    item.state = 1;
	                                    item.msg = '';
	                                } else {
	                                    item.state = 2;
	                                    item.msg = '第一项和第二项不相等';
	                                }
	                            });
	                        }, 300);
	                    }
	                }],
	                resetCb: function resetCb(item, i) {
	                    if (item.timerId) {
	                        clearTimeout(item.timerId);
	                        item.timerId = null;
	                    }
	                },
	
	                state: 0,
	                msg: ''
	            }],
	            tagOptions1: {
	                'class': 'form1',
	                'style': { paddingLeft: '10px' }
	            },
	            tagOptions2: {
	                'class': { form2: true },
	                'style': { paddingLeft: '10px' }
	            }
	        };
	    },
	
	    methods: {
	        initForm1: function initForm1() {
	            this.$refs.leoForm1.initForm();
	        },
	        initForm: function initForm() {
	            this.$refs.leoForm.initForm();
	        },
	        reset1: function reset1() {
	            this.$refs.leoForm1.resetFields();
	        },
	        submit1: function submit1(op) {
	            this.$refs.leoForm1.validate(op).then(function (result) {
	                leoAlert(result);
	            }).catch(function (result) {
	                console.log('catch');
	                leoAlert(result);
	            });
	            console.log(this.$refs.leoForm1.getFormData());
	        },
	        reset: function reset() {
	            this.$refs.leoForm.resetFields();
	        },
	        submit: function submit(op) {
	            this.$refs.leoForm.validate(op).then(function (result) {
	                leoAlert(result);
	            }).catch(function (result) {
	                console.log('catch');
	                leoAlert(result);
	            });
	            console.log(this.$refs.leoForm.getFormData());
	        },
	        add: function add() {
	            this.form1.push({
	                key: 'formKey' + (this.form1.length + 1),
	                value: '',
	                rules: [{
	                    rule: function rule(value, _rule4, item, cb) {
	                        if ('leo好帅' === value) {
	                            item.state = 1;
	                            item.msg = '';
	                        } else {
	                            item.state = 2;
	                            item.msg = '请输入leo好帅';
	                        }
	                        cb();
	                    }
	                }],
	                state: 0,
	                msg: ''
	            });
	        },
	        deleteItem: function deleteItem(item) {
	            this.$refs.leoForm.removeField(item);
	        },
	        deleteItem1: function deleteItem1(item) {
	            var forms = this.form1;
	            var index = forms.indexOf(item);
	            if (index > -1) {
	                forms.splice(index, 1);
	            }
	        }
	    }
	};

/***/ },

/***/ 56:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var telephoneRe = /^1[3|4|5|7|8][0-9]{9}$/;
	var passwordRe = /^\w{6,16}$/;
	var codeRe = /^[1-9]\d{5}$/;
	
	var ruleFn = exports.ruleFn = {
	    isPhone: function isPhone(val, rule, item, cb) {
	        var tip = '手机号码格式不对';
	        if (telephoneRe.test(val)) {
	            item.state = 1;
	            item.msg = '';
	        } else {
	            item.state = 2;
	            item.msg = rule.tip ? rule.tip : tip;
	        }
	        cb();
	    },
	    isCode: function isCode(val, rule, item, cb) {
	        var tip = '邮政编码不正确';
	        if (codeRe.test(val)) {
	            item.state = 1;
	            item.msg = '';
	        } else {
	            item.state = 2;
	            item.msg = rule.tip ? rule.tip : tip;
	        }
	        cb();
	    },
	    password: function password(val, rule, item) {
	        var tip = '密码6-16位';
	        if (passwordRe.test(val)) {
	            item.state = 1;
	            item.msg = '';
	        } else {
	            item.state = 2;
	            item.msg = rule.tip ? rule.tip : tip;
	        }
	        cb();
	    },
	    required: function required(val, rule, item, cb) {
	        var tip = '必填!';
	        if (val) {
	            item.state = 1;
	            item.msg = '';
	        } else {
	            item.state = 2;
	            item.msg = rule.tip ? rule.tip : tip;
	        }
	        cb();
	    },
	    isPositive: function isPositive(val, rule, item, cb) {
	        var tip = '大于0!';
	        if (val > 0) {
	            item.state = 1;
	            item.msg = '';
	        } else {
	            item.state = 2;
	            item.msg = rule.tip ? rule.tip : tip;
	        }
	        cb();
	    },
	    right: function right(val, rule, item, cb) {
	        var tip = '正确!';
	        if (val === true) {
	            item.state = 1;
	            item.msg = '';
	        } else {
	            item.state = 2;
	            item.msg = rule.tip ? rule.tip : tip;
	        }
	        cb();
	    }
	};

/***/ },

/***/ 57:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(39);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.type = type;
	exports.extend = extend;
	exports.isPromise = isPromise;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var class2type = {};
	"Boolean Number String Function Array Date RegExp Object".split(" ").forEach(function (name) {
	    class2type["[object " + name + "]"] = name.toLowerCase();
	});
	
	var toString = Object.prototype.toString;
	function type(obj) {
	    return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
	}
	
	function extend() {
	    var options = void 0,
	        name = void 0,
	        src = void 0,
	        copy = void 0,
	        copyIsArray = void 0,
	        clone = void 0,
	        target = arguments[0] || {},
	        i = 1,
	        length = arguments.length,
	        deep = false;
	
	    if (typeof target === "boolean") {
	        deep = target;
	        target = arguments[i] || {};
	        i++;
	    }
	
	    if ((typeof target === "undefined" ? "undefined" : (0, _typeof3.default)(target)) !== "object" && type(target) !== 'function') {
	        target = {};
	    }
	
	    if (i === length) {
	        target = this;
	        i--;
	    }
	
	    for (; i < length; i++) {
	        if ((options = arguments[i]) != null) {
	            for (name in options) {
	                src = target[name];
	                copy = options[name];
	                if (target === copy) {
	                    continue;
	                }
	                if (deep && copy && (type(copy) === 'object' || (copyIsArray = Array.isArray(copy)))) {
	                    if (copyIsArray) {
	                        copyIsArray = false;
	                        clone = src && Array.isArray(src) ? src : [];
	                    } else {
	                        clone = src && type(src) === 'object' ? src : {};
	                    }
	                    target[name] = extend(deep, clone, copy);
	                } else if (copy !== undefined) {
	                    target[name] = copy;
	                }
	            }
	        }
	    }
	    return target;
	}
	
	function isPromise(val) {
	    if (val && val.then && type(val.then) === 'function') {
	        return true;
	    }
	    return false;
	}

/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _symbol = __webpack_require__(38);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _regenerator = __webpack_require__(67);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(66);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(37);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(64);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _typeof2 = __webpack_require__(39);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(36);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _freeze = __webpack_require__(62);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _extends2 = __webpack_require__(65);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _utils = __webpack_require__(57);
	
	var _rules = __webpack_require__(56);
	
	var _vue = __webpack_require__(54);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'leo-validator',
	    render: function render(h) {
	        var tagOptions = this.tagOptions || null;
	        return h(this.tag || 'span', (0, _extends3.default)({}, tagOptions), this.$slots.default || []);
	    },
	    data: function data() {
	        return (0, _freeze2.default)({
	            initFormsData: {}
	        });
	    },
	
	    props: {
	        forms: {
	            type: Array,
	            required: true,
	            'default': function _default() {
	                return [];
	            }
	        },
	        tag: {
	            type: String,
	            'default': 'span'
	        },
	        tagOptions: {
	            type: Object
	        }
	    },
	    watch: {
	        forms: function forms(newVal, oldVal) {
	            if (this.leoFormInit) {
	                if (newVal.length < this.leoFormLength && !this.isLeoValidatorRemove) {
	                    throw new Error('必须使用removeField删除！');
	                }
	                this.initForms();
	                this.addAllWatch();
	                this.leoFormLength = newVal.length;
	                this.isLeoValidatorRemove = false;
	            }
	        }
	    },
	    created: function created() {
	        this.initNotify();
	    },
	    destroyed: function destroyed() {
	        this.removeAllWatch();
	        this.destroyNotify();
	    },
	
	    methods: {
	        initForm: function initForm() {
	            if (!this.leoFormInit) {
	                this.initForms();
	                this.addAllWatch();
	                this.leoFormInit = true;
	                this.leoFormLength = this.forms.length;
	                this.isLeoValidatorRemove = false;
	            }
	        },
	        getFormData: function getFormData() {
	            var data = {},
	                forms = this.forms;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(forms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var val = _step.value;
	
	                    data[val.key] = this.getItemValue(val.value);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return data;
	        },
	        addAllWatch: function addAllWatch() {
	            var _this = this;
	
	            this.forms.forEach(function (item, i) {
	                item.__unwatch && item.__unwatch();
	                item.__unwatch = _this.$watch('forms.' + i + '.value', function (newVal, oldVal) {
	                    if (item.__enable) {
	                        _this.validateField(item);
	                    }
	                }, {
	                    deep: !!item.deep
	                });
	            });
	        },
	        getItemValue: function getItemValue(value) {
	            if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== 'object') {
	                return value;
	            } else {
	                var dest = Array.isArray(value) ? [] : {};
	                return (0, _utils.extend)(true, dest, value);
	            }
	        },
	        setItemValue: function setItemValue(items, value) {
	            var src = items.value;
	            if ((typeof src === 'undefined' ? 'undefined' : (0, _typeof3.default)(src)) !== 'object') {
	                items.value = value;
	            } else {
	                (0, _utils.extend)(true, src, value);
	            }
	        },
	        initForms: function initForms() {
	            var _this2 = this;
	
	            var initFormsData = this.initFormsData;
	            this.forms.forEach(function (item, i) {
	                var initItem = initFormsData[item.key];
	                if (!initItem) {
	                    initFormsData[item.key] = {
	                        value: _this2.getItemValue(item.value),
	                        msg: item.msg
	                    };
	                    item.__enable = true;
	                    item.state = 0;
	                    item.__promiseHash = {};
	                } else {
	                    item.__enable = false;
	                    _this2.$nextTick(function () {
	                        item.__enable = true;
	                    });
	                }
	            });
	        },
	        resetFields: function resetFields() {
	            var _this3 = this;
	
	            if (!this.leoFormInit) {
	                throw new Error('请初始化');
	            }
	            var initFormsData = this.initFormsData;
	            this.forms.forEach(function (item, i) {
	                var initItem = initFormsData[item.key];
	                if (initItem) {
	                    item.__enable = false;
	                    _this3.setItemValue(item, initItem.value);
	                    item.msg = initItem.msg;
	                    _this3.$nextTick(function () {
	                        item.__enable = true;
	                    });
	                }
	                item.state = 0;
	                item.__promiseHash = {};
	                if ((0, _utils.type)(item.resetCb) === 'function') {
	                    item.resetCb(item, i);
	                }
	            });
	            this.bus.$emit('notify', {
	                info: 'reset'
	            });
	        },
	        removeAllWatch: function removeAllWatch() {
	            this.forms.forEach(function (item, i) {
	                item.__unwatch && item.__unwatch();
	                item.__promiseHash = null;
	            });
	        },
	        removeField: function removeField(items) {
	            var _this4 = this;
	
	            var arr = Array.isArray(items) ? items : [items];
	            arr.forEach(function (item) {
	                var forms = _this4.forms;
	                var index = forms.indexOf(item);
	                if (index > -1) {
	                    item.__unwatch && item.__unwatch();
	                    forms.splice(index, 1);
	                    item.__promiseHash = null;
	                    delete _this4.initFormsData[item.key];
	                }
	            });
	            this.isLeoValidatorRemove = true;
	        },
	        innerValidate: function innerValidate() {
	            var _this5 = this;
	
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
	            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                var forms, result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step2$value, index, form;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (_this5.leoFormInit) {
	                                    _context.next = 2;
	                                    break;
	                                }
	
	                                return _context.abrupt('return', new _promise2.default(function (resolve, reject) {
	                                    reject('请初始化');
	                                }));
	
	                            case 2:
	                                forms = _this5.forms;
	                                result = {
	                                    valid: true,
	                                    msgs: [],
	                                    form: {}
	                                };
	                                _context.prev = 4;
	                                _iteratorNormalCompletion2 = true;
	                                _didIteratorError2 = false;
	                                _iteratorError2 = undefined;
	                                _context.prev = 8;
	                                _iterator2 = (0, _getIterator3.default)(forms.entries());
	
	                            case 10:
	                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                    _context.next = 21;
	                                    break;
	                                }
	
	                                _step2$value = (0, _slicedToArray3.default)(_step2.value, 2), index = _step2$value[0], form = _step2$value[1];
	                                _context.next = 14;
	                                return _this5.validateField(form);
	
	                            case 14:
	                                if (form.state > 1) {
	                                    result.valid = false;
	                                    result.msgs.push(form.msg);
	                                }
	                                result.form[form.key] = {
	                                    value: _this5.getItemValue(form.value),
	                                    msg: form.msg,
	                                    state: form.state,
	                                    index: index
	                                };
	
	                                if (!(mode === 'first' && form.state == 2)) {
	                                    _context.next = 18;
	                                    break;
	                                }
	
	                                return _context.abrupt('return', result);
	
	                            case 18:
	                                _iteratorNormalCompletion2 = true;
	                                _context.next = 10;
	                                break;
	
	                            case 21:
	                                _context.next = 27;
	                                break;
	
	                            case 23:
	                                _context.prev = 23;
	                                _context.t0 = _context['catch'](8);
	                                _didIteratorError2 = true;
	                                _iteratorError2 = _context.t0;
	
	                            case 27:
	                                _context.prev = 27;
	                                _context.prev = 28;
	
	                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                    _iterator2.return();
	                                }
	
	                            case 30:
	                                _context.prev = 30;
	
	                                if (!_didIteratorError2) {
	                                    _context.next = 33;
	                                    break;
	                                }
	
	                                throw _iteratorError2;
	
	                            case 33:
	                                return _context.finish(30);
	
	                            case 34:
	                                return _context.finish(27);
	
	                            case 35:
	                                _context.next = 40;
	                                break;
	
	                            case 37:
	                                _context.prev = 37;
	                                _context.t1 = _context['catch'](4);
	                                return _context.abrupt('return', {
	                                    info: _context.t1,
	                                    result: result
	                                });
	
	                            case 40:
	                                return _context.abrupt('return', result);
	
	                            case 41:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this5, [[4, 37], [8, 23, 27, 35], [28,, 30, 34]]);
	            }))();
	        },
	        initNotify: function initNotify() {
	            var _this6 = this;
	
	            this.bus = new _vue2.default();
	            this.bus.$on('notify', function (msg) {
	                _this6.__offValidate && _this6.__offValidate(msg);
	            });
	            this.__offValidate = null;
	        },
	        destroyNotify: function destroyNotify() {
	            this.bus.$off('notify');
	            this.bus = null;
	            this.__offValidate = null;
	        },
	        validate: function validate(mode) {
	            var _this7 = this;
	
	            return _promise2.default.race([this.innerValidate(mode), new _promise2.default(function (resolve, reject) {
	                _this7.__offValidate = reject;
	            })]);
	        },
	        validateOne: function validateOne(item, rule, index) {
	            var fn = void 0;
	            if ((0, _utils.type)(rule) === 'function') {
	                fn = rule;
	            } else {
	                var ruleName = void 0;
	                if (rule.rule) {
	                    ruleName = rule.rule;
	                }
	                if (typeof ruleName === 'string' && typeof _rules.ruleFn[ruleName] === 'function') {
	                    fn = _rules.ruleFn[ruleName];
	                } else if ((0, _utils.type)(ruleName) === 'function') {
	                    fn = ruleName;
	                }
	            }
	            if (fn) {
	                return new _promise2.default(function (resolve, reject) {
	                    var id = void 0;
	                    if (item.__promiseHash) {
	                        id = (0, _symbol2.default)();
	                        item.__promiseHash[id] = true;
	                    }
	                    item.state = 3;
	                    fn(item.value, rule, item, function (cb) {
	                        if (item.__promiseHash && item.__promiseHash[id]) {
	                            cb && cb(item.value, rule, item, index);
	                            delete item.__promiseHash[id];
	                            resolve();
	                        }
	                        id = null;
	                    }, index);
	                });
	            }
	        },
	        validateField: function validateField(item) {
	            var _this8 = this;
	
	            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	                var rules, len, i;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (!(item.state === 3)) {
	                                    _context2.next = 2;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 2:
	                                rules = item.rules;
	
	                                if (rules) {
	                                    _context2.next = 5;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 5:
	                                if (!Array.isArray(rules)) {
	                                    _context2.next = 27;
	                                    break;
	                                }
	
	                                len = rules.length;
	
	                                if (!(len === 0)) {
	                                    _context2.next = 9;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 9:
	                                i = 0;
	
	                            case 10:
	                                if (!(i < len)) {
	                                    _context2.next = 26;
	                                    break;
	                                }
	
	                                _context2.prev = 11;
	                                _context2.next = 14;
	                                return _this8.validateOne(item, rules[i], i);
	
	                            case 14:
	                                _context2.next = 21;
	                                break;
	
	                            case 16:
	                                _context2.prev = 16;
	                                _context2.t0 = _context2['catch'](11);
	
	                                if ((0, _utils.type)(item.errorCb) === 'function') {
	                                    item.errorCb(_context2.t0, item, i);
	                                }
	                                _this8.bus.$emit('notify', {
	                                    info: 'error',
	                                    result: item
	                                });
	                                return _context2.abrupt('return', _context2.t0);
	
	                            case 21:
	                                if (!(item.state != 1)) {
	                                    _context2.next = 23;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 23:
	                                i++;
	                                _context2.next = 10;
	                                break;
	
	                            case 26:
	                                return _context2.abrupt('return');
	
	                            case 27:
	                                return _context2.abrupt('return', _this8.validateOne(item, rules));
	
	                            case 28:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this8, [[11, 16]]);
	            }))();
	        }
	    }
	};

/***/ },

/***/ 110:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 114:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(110)
	
	/* script */
	__vue_exports__ = __webpack_require__(55)
	
	/* template */
	var __vue_template__ = __webpack_require__(115)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 115:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('h1', ["\n        leo-vue-validator例子\n    "]), " ", _h('h3', ["\n        注意事项：必须先点击初始化按钮或者调用(initForm接口)才能验证\n    "]), " ", _h('h3', ["\n        状态参数（state）： 0: 没有验证过, 1: 通过, 2: 不通过, 3: 验证中\n    "]), " ", _h('h3', ["\n        自定义回调：\n        1.必须要设置item.state = 1才能验证下面的事项\n        2.必须调用回调参数cb()验证才开始\n    "]), " ", _h('h3', ["\n        改变forms中value的值 都会进行验证\n    "]), " ", _h('leo-validator', {
	    ref: "leoForm",
	    attrs: {
	      "forms": _vm.form1,
	      "tag": "div",
	      "tagOptions": _vm.tagOptions1
	    }
	  }, [_h('h1', ["表单1(动态添加表单)"]), " ", _h('ul', {
	    staticClass: "MoUpFlo_Module MoUpFlo_enterInfo"
	  }, [_vm._l((_vm.form1), function(item, index) {
	    return _h('li', {
	      staticClass: "clearfix"
	    }, [_h('label', [_h('span', ["item" + _vm._s(index) + ": "]), " ", _h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.value),
	        expression: "item.value"
	      }],
	      staticClass: "infoVal",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(item.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          item.value = $event.target.value
	        }
	      }
	    })]), " ", _h('div', [_h('button', {
	      on: {
	        "click": function($event) {
	          _vm.deleteItem(item)
	        }
	      }
	    }, ["删除"]), " ", _h('button', {
	      on: {
	        "click": function($event) {
	          _vm.deleteItem1(item)
	        }
	      }
	    }, ["删除(不使用removeField 报错,初始化后）)"])]), " ", _h('p', ["状态：" + _vm._s(item.state) + "    提示：" + _vm._s(item.msg)])])
	  })]), " ", _h('button', {
	    on: {
	      "click": _vm.initForm
	    }
	  }, ["初始化"]), " ", _h('button', {
	    on: {
	      "click": _vm.add
	    }
	  }, ["添加"]), " ", _h('button', {
	    on: {
	      "click": _vm.reset
	    }
	  }, ["重置"]), " ", _h('div', [_h('button', {
	    on: {
	      "click": function($event) {
	        _vm.submit('all')
	      }
	    }
	  }, ["提交(全部验证)"]), " ", _h('button', {
	    on: {
	      "click": function($event) {
	        _vm.submit('first')
	      }
	    }
	  }, ["提交（验证到第一个错误项）"])])]), " ", _h('leo-validator', {
	    ref: "leoForm1",
	    attrs: {
	      "forms": _vm.form2,
	      "tag": "div",
	      "tagOptions": _vm.tagOptions2
	    }
	  }, [_h('h1', ["表单2"]), " ", _h('ul', [_h('li', {
	    staticClass: "clearfix"
	  }, [_h('label', [_h('span', ["没有验证 : "]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form2[1]['value']),
	      expression: "form2[1]['value']"
	    }],
	    staticClass: "infoVal",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.form2[1]['value'])
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        var $$exp = _vm.form2[1],
	          $$idx = 'value';
	        if (!Array.isArray($$exp)) {
	          _vm.form2[1]['value'] = $event.target.value
	        } else {
	          $$exp.splice($$idx, 1, $event.target.value)
	        }
	      }
	    }
	  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[1]['state']) + "    提示：" + _vm._s(_vm.form2[1]['msg'])])]), " ", _h('li', {
	    staticClass: "clearfix"
	  }, [_h('label', [_h('span', ["手机号 : "]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form2[0]['value']),
	      expression: "form2[0]['value']"
	    }],
	    staticClass: "infoVal",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.form2[0]['value'])
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        var $$exp = _vm.form2[0],
	          $$idx = 'value';
	        if (!Array.isArray($$exp)) {
	          _vm.form2[0]['value'] = $event.target.value
	        } else {
	          $$exp.splice($$idx, 1, $event.target.value)
	        }
	      }
	    }
	  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[0]['state']) + "    提示：" + _vm._s(_vm.form2[0]['msg'])])]), " ", _h('li', {
	    staticClass: "clearfix"
	  }, [_h('label', [_h('span', ["异步验证整组验证 : "]), " ", _h('p', ["（obj形式 失去焦点验证 password: 123456）"]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.form2[2]['value']['user']),
	      expression: "form2[2]['value']['user']",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "infoVal",
	    attrs: {
	      "placeholder": "user",
	      "type": "text",
	      "disabled": _vm.form2[2]['state'] == 3
	    },
	    domProps: {
	      "value": _vm._s(_vm.form2[2]['value']['user'])
	    },
	    on: {
	      "change": function($event) {
	        var $$exp = _vm.form2[2]['value'],
	          $$idx = 'user';
	        if (!Array.isArray($$exp)) {
	          _vm.form2[2]['value']['user'] = $event.target.value
	        } else {
	          $$exp.splice($$idx, 1, $event.target.value)
	        }
	      }
	    }
	  }), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.form2[2]['value']['password']),
	      expression: "form2[2]['value']['password']",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "infoVal",
	    attrs: {
	      "placeholder": "password",
	      "type": "text",
	      "disabled": _vm.form2[2]['state'] == 3
	    },
	    domProps: {
	      "value": _vm._s(_vm.form2[2]['value']['password'])
	    },
	    on: {
	      "change": function($event) {
	        var $$exp = _vm.form2[2]['value'],
	          $$idx = 'password';
	        if (!Array.isArray($$exp)) {
	          _vm.form2[2]['value']['password'] = $event.target.value
	        } else {
	          $$exp.splice($$idx, 1, $event.target.value)
	        }
	      }
	    }
	  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[2]['state']) + "    提示：" + _vm._s(_vm.form2[2]['msg'])])]), " ", _h('li', {
	    staticClass: "clearfix"
	  }, [_h('label', [_h('span', ["异步验证整组验证（array形式 失去焦点验证） : "]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.form2[3].value[0]),
	      expression: "form2[3].value[0]",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "infoVal",
	    attrs: {
	      "type": "text",
	      "disabled": _vm.form2[3]['state'] == 3
	    },
	    domProps: {
	      "value": _vm._s(_vm.form2[3].value[0])
	    },
	    on: {
	      "change": function($event) {
	        var $$exp = _vm.form2[3].value,
	          $$idx = 0;
	        if (!Array.isArray($$exp)) {
	          _vm.form2[3].value[0] = $event.target.value
	        } else {
	          $$exp.splice($$idx, 1, $event.target.value)
	        }
	      }
	    }
	  }), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.form2[3].value[1]),
	      expression: "form2[3].value[1]",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "infoVal",
	    attrs: {
	      "type": "text",
	      "disabled": _vm.form2[3]['state'] == 3
	    },
	    domProps: {
	      "value": _vm._s(_vm.form2[3].value[1])
	    },
	    on: {
	      "change": function($event) {
	        var $$exp = _vm.form2[3].value,
	          $$idx = 1;
	        if (!Array.isArray($$exp)) {
	          _vm.form2[3].value[1] = $event.target.value
	        } else {
	          $$exp.splice($$idx, 1, $event.target.value)
	        }
	      }
	    }
	  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[3]['state']) + "    提示：" + _vm._s(_vm.form2[3]['msg'])])])]), " ", _h('button', {
	    on: {
	      "click": _vm.initForm1
	    }
	  }, ["初始化"]), " ", _h('button', {
	    on: {
	      "click": _vm.reset1
	    }
	  }, ["重置"]), " ", _h('div', [_h('button', {
	    on: {
	      "click": function($event) {
	        _vm.submit1('all')
	      }
	    }
	  }, ["提交(全部验证)"]), " ", _h('button', {
	    on: {
	      "click": function($event) {
	        _vm.submit1('first')
	      }
	    }
	  }, ["提交（验证到第一个错误项）"])])])])
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.e950a86b08f93be70e35.js